/**
 * Espelho client-side da função homônima em
 * `backend/src/services/sdrConversationBlocksStore.ts`. Mantida em
 * sincronia para que o preview do tenant seja **idêntico** ao
 * `systemPromptDerived` que o servidor calcula no PUT.
 *
 * Política de blocos vazios: body em branco → bloco inteiro omitido
 * (não vai como "## Título" + "_(em branco)_"). Evita poluir o prompt LLM.
 */
import { SdrBlock } from '../../types';

export function buildAtendenteMarkdown(blocks: SdrBlock[], title?: string): string {
  const sorted = [...blocks].sort((a, b) => a.order - b.order);
  let md = title ? `# ${title}\n\n` : '';
  for (const block of sorted) {
    const body = (block.body || '').trim();
    if (!body) continue;
    const heading = '#'.repeat(block.level);
    md += `${heading} ${block.title}\n\n`;
    md += `${body}\n\n`;
  }
  return md.trimEnd() + '\n';
}

/** `true` quando nenhum block tem body preenchido. Caller usa pra UI hint. */
export function isAllBlocksEmpty(blocks: SdrBlock[]): boolean {
  if (!blocks || blocks.length === 0) return true;
  return blocks.every((b) => !(b.body || '').trim());
}
